const pad = (value: number, length = 2) => value.toString().padStart(length, '0')

export const formatDateLocalToBack = (date: unknown) => {
  if (!date) return undefined

  const parsedDate = date instanceof Date ? date : new Date(date as string | number)
  if (Number.isNaN(parsedDate.getTime())) return undefined

  return [
    pad(parsedDate.getFullYear(), 4),
    pad(parsedDate.getMonth() + 1),
    pad(parsedDate.getDate()),
  ].join('-')
}

export const getMonthRangeUpToToday = (selected: unknown): Date[] => {
  const parsedDate = selected instanceof Date ? selected : new Date(selected as string | number)
  const reference = Number.isNaN(parsedDate.getTime()) ? new Date() : parsedDate

  const year = reference.getFullYear()
  const month = reference.getMonth()

  const firstDayMonth = new Date(year, month, 1, 0, 0, 0)
  const lastDayMonth = new Date(year, month + 1, 0, 23, 59, 59)
  const today = new Date()

  return [firstDayMonth, lastDayMonth > today ? today : lastDayMonth]
}

export const formatDateTimeLocalToBack = (date: unknown, includeMilliseconds = false) => {
  if (!date) return null

  const parsedDate = date instanceof Date ? date : new Date(date as string | number)
  if (Number.isNaN(parsedDate.getTime())) return null

  const dateTime = [
    pad(parsedDate.getFullYear(), 4),
    '-',
    pad(parsedDate.getMonth() + 1),
    '-',
    pad(parsedDate.getDate()),
    'T',
    pad(parsedDate.getHours()),
    ':',
    pad(parsedDate.getMinutes()),
    ':',
    pad(parsedDate.getSeconds()),
  ].join('')

  return includeMilliseconds ? `${dateTime}.${pad(parsedDate.getMilliseconds(), 3)}` : dateTime
}
